/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react'
import EventIcon from '@mui/icons-material/Event'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import { DesktopTimePicker, MobileTimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import block from 'bem-cn'
import dayjs from 'dayjs'

import { useMediaDevice } from '@bcraft-frontend-lib/core'

import './TimePicker.scss'

type CustomDatePickerProps = {
  defaultValue: dayjs.Dayjs | Date
  callback: (date: string) => void
  format?: string
  [x: string]: any
}

const b = block('time-picker')

const TimePicker: React.FC<CustomDatePickerProps> = ({
  defaultValue,
  callback,
  format = 'YYYY-MM-DDTHH:mmZ',
  ...props
}) => {
  const isMobileOrTablet = useMediaDevice({ query: 'maxTablet' })

  const onChangeDate = (newDate: any) => {
    callback(dayjs(newDate.$d).format(format))
  }

  return (
    <div className={b()}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        {isMobileOrTablet ? (
          <MobileTimePicker
            minTime={dayjs('2017-01-01')}
            value={defaultValue}
            onChange={newValue => {
              onChangeDate(newValue)
            }}
            renderInput={params => (
              <TextField
                {...params}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton edge="end">
                        <EventIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            )}
            {...props}
          />
        ) : (
          <DesktopTimePicker
            minTime={dayjs('2017-01-01')}
            value={defaultValue}
            onChange={newValue => {
              onChangeDate(newValue)
            }}
            renderInput={params => <TextField {...params} />}
            {...props}
          />
        )}
      </LocalizationProvider>
    </div>
  )
}

export default TimePicker
